<template>
    <div class=" widget-calendar">
        <card header-classes="bg-transparent">
            <template v-slot:header>
                <h5 class="h3 mb-0">GC Memory Usage</h5>
            </template>
            <div class=" ">
                <canvas :height="260" :id="doughnetChartID"></canvas>
            </div>
        </card>
    </div>
</template>
<script>
import Chart from "chart.js";
let chart;
export default {
    name: "memoryUsage",
    components: {
    },
    data() {
        return {
            gcLiveSize: "",
            gcMaxSize: "",
            doughnetChartID: "ordersChart",
        };
    },
    methods: {
        createDoughnetChart() {
            const ctx = document.getElementById(this.doughnetChartID).getContext("2d");
            if (this.doughnetChart) {
                this.doughnetChart.destroy();
            }
            this.doughnetChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                    labels: ["Used", "Free"],
                    datasets: [
                        {
                            label: "Dataset 1",
                            tension: 0.4,
                            data: [Number(this.gcLiveSize), (Number(this.gcMaxSize) - Number(this.gcLiveSize)).toFixed(2)],
                            backgroundColor: [
                                "#f5365c",
                                "#11cdef",
                                "#2dce89",
                                "#5e72e4",
                                "#11cdef",
                            ],
                            showLine: false,
                            barPercentage: 1.6,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutoutPercentage: 45,
                    rotation: Math.PI,
                    circumference: 2 * Math.PI,
                    legend: {
                        display: true,
                        position: "bottom",
                        labels: {
                            boxWidth: 20,
                            font: { size: 14, weight: "bold" },
                        },
                    },
                    tooltips: {
                        enabled: true,
                        mode: "index",
                        intersect: false,
                    },
                    scales: {
                        display: false,
                        yAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "transparent",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    display: false,
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "transparent",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    display: false,
                                },
                            },
                        ],
                    },
                    pluginLabels: {
                        gcMaxSize: this.gcMaxSize,
                        gcLiveSize: this.gcLiveSize,
                    },
                    layout: {
                        padding: 15,
                    },
                },
                plugins: [
                    {
                        id: "centerValue",
                        afterDraw: (chart) => {
                            const { ctx, width, height } = chart;
                            const pluginLabels = chart.options.pluginLabels;
                            const gcMaxSize = pluginLabels.gcMaxSize || "0";
                            ctx.font = "bold 18px Open Sans";
                            ctx.textAlign = "center";
                            ctx.textBaseline = "middle";
                            ctx.fillStyle = "#8898aa";
                            ctx.fillText(`${gcMaxSize} GB`, width / 2, height / 2.4);
                        },
                    },
                    {
                        id: "sectionLabels",
                        afterDraw: (chart) => {
                            const { ctx } = chart;
                            const meta = chart.getDatasetMeta(0);
                            ctx.textBaseline = "middle";
                            ctx.textAlign = "center";
                            meta.data.forEach((element, index) => {
                                const model = element.tooltipPosition();
                                const value = parseFloat(chart.data.datasets[0].data[index]);
                                if (value === 0 || value < 0.03) return;
                                let fontSize = 14;
                                let fontColor = "#ffffff";
                                if (value < 0.08) {
                                    ctx.save();
                                    ctx.translate(model.x, model.y);
                                    ctx.fillStyle = "#ffffff";
                                    ctx.font = "bold 12px sans-serif";
                                    ctx.fillText(`${value}GB`, 0, 0);
                                    ctx.restore();
                                } else {
                                    ctx.fillStyle = fontColor;
                                    ctx.font = `bold ${fontSize}px sans-serif`;
                                    ctx.fillText(`${value}GB`, model.x, model.y);
                                }
                            });
                        },
                    },
                ],
            });
        },
        formatBytes(bytes) {
            const gigabytes = bytes / (1024 ** 3);
            const formattedGB = gigabytes.toFixed(2);
            return formattedGB;
        },
        getGcMaxSize(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    const bytes = response.server.data[0].value;
                    this.gcMaxSize = this.formatBytes(bytes);
                    this.createDoughnetChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getGcLiveSize(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    const bytes = response.server.data[0].value;
                    this.gcLiveSize = this.formatBytes(bytes);
                    this.createDoughnetChart();
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
    mounted() {
        this.getGcLiveSize("GC_LIVE_SIZE");
        this.getGcMaxSize("GC_MAX_SIZE");
    }
};
</script>